import Vue from 'vue'
import axios from 'axios'
import {$i18n} from './i18n'
import {GATEWAY_CONNECTION_ERROR, QUOTA_REACHED, SUBSCRIPTION_NOT_FOUND, VIP_ONLY, PAYLOAD_INVALID, RECORD_NOT_FOUND, RECORD_OWNER_ERROR, GATEWAY_VALIDATION_ERROR} from '@/error_codes'
import {getOrStartRefresh} from './authRefresh'

const $axios = axios.create({
  baseURL: process.env.VUE_APP_API_URL || process.env.BASE_URL || 'http://localhost:3000',
  devURL: process.env.VUE_APP_DEV_URL || process.env.BASE_DEV_URL || 'http://localhost:3000',
  // fixme: reduce timeout for non-development environment after optimization to routes api
  timeout: process.env.NODE_ENV === 'development' ? 600000 : 1200000
});

$axios.interceptors.response.use((response) => {
    return response
  },
  (error) => {
    const config = error.config
    if (error.response?.status === 401 && config && !config._retry) {
      return getOrStartRefresh()
        .then(() => {
          config._retry = true
          return $axios.request(config)
        })
        .catch((refreshErr) => {
          return Promise.reject({ error: error.response ? error : refreshErr, errors: [$i18n('message.request_error')] })
        })
    }

    if (error.response && error.response.data) {
      const errorData = error.response.data;
      const vue = new Vue();
      if (errorData.error_code === SUBSCRIPTION_NOT_FOUND) {
        vue.$message.error($i18n('ErrorOccurred') + ': ' + $i18n('message.SubscriptionNotFound'), 15);
      }
      if (errorData.error_code === GATEWAY_CONNECTION_ERROR) {
        vue.$message.error($i18n('ErrorOccurred') + ': ' + $i18n('message.GatewayConnectionError'), 15);
      }
      if (errorData.error_code === QUOTA_REACHED) {
        vue.$message.error($i18n('ErrorOccurred') + ': ' + $i18n('message.QuotaReached'), 5);
      }
      if (errorData.error_code === VIP_ONLY) {
        vue.$message.error($i18n('ErrorOccurred') + ': ' + $i18n('message.VipOnly'), 10);
      }
      if (errorData.error_code === PAYLOAD_INVALID) {
        vue.$message.error($i18n('ErrorOccurred') + ': ' + $i18n('message.PayloadInvalid'), 8);
      }
      if (errorData.error_code === RECORD_NOT_FOUND) {
        vue.$message.error($i18n('ErrorOccurred') + ': ' + $i18n('message.RecordNotFound'), 8);
      }
      if (errorData.error_code === RECORD_OWNER_ERROR) {
        vue.$message.error($i18n('ErrorOccurred') + ': ' + $i18n('message.RecordOwnerError'), 10);
      }
      if (errorData.error_code === GATEWAY_VALIDATION_ERROR) {
        vue.$message.error($i18n('ErrorOccurred') + ': ' + $i18n('message.GatewayValidationError'), 8);
      }
    }

    let errors = []
    if (error.response) {
        if (error.response.data instanceof Object) {
            for (let key in error.response.data) {
                if( key == "success" && error.response.data[key] == false) {
                    continue;
                }
                errors.push(key + "." + error.response.data[key]);
            }
        } else if (error.response.data.message) {
            errors.push(error.response.data.message);
        } else {
            errors.push($i18n('message.request_error'));
        }
    } else {
      errors.push($i18n('message.network_error'));
    }

    return Promise.reject({error, errors});
  });

export default $axios;
